import { render, staticRenderFns } from "./PickerColor.vue?vue&type=template&id=ae621d36&scoped=true&"
import script from "./PickerColor.vue?vue&type=script&lang=js&"
export * from "./PickerColor.vue?vue&type=script&lang=js&"
import style0 from "./PickerColor.vue?vue&type=style&index=0&id=ae621d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae621d36",
  null
  
)

export default component.exports